// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1hWIf","select":"Header_select__3NAYD","clinic":"Header_clinic__qbOMI"};